module.exports = __webpack_public_path__ + "static/FrankensteinCards-1-89a0cabb68c0a4700fc0db83391bab1c.jpg";